module.exports = __webpack_public_path__ + "media/hallBgm.b5028beb.mp3";